import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-098d4aa2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "iodine-scrollable-y browse-reference" }
const _hoisted_2 = { class: "row items-center browse-result-item iodine-padding-left-sm" }

import {ref} from 'vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesBrowse',
  setup(__props) {

    const expanded = ref([ '2023', 'ICD-10-CM Conventions', 'Introduction Overview' ]);
    const selected = ref(null)
    const browseReference = [
        {
            label: '2024',
            children: [
                {
                    label: 'ICD-10-CM Conventions1',
                    children: [
                        {
                            label: 'ICD-10-CM Conventions2',
                            children: [
                                { label: 'ICD-10-CM Conventions3' },
                            ]
                        },
                    ]
                },
            ]
        },
        {
            label: '2023',
            children: [
                {
                    label: 'ICD-10-CM Conventions4',
                    children: [
                        { label: 'ICD-10-CM Conventions5' },
                        { label: 'Introduction Overview' },
                        { label: 'Instructional Notes' },
                        { label: 'Abbreviations' },
                        { label: 'Cross-reference Notes' },
                        { label: 'Punctuation Marks' },
                        { label: 'Exercise 2.1' },
                        { label: 'Exercise 2.2' },
                        { label: 'Relational Terms' }
                    ]
                },
                {
                    label: 'Uniform Hospital Discharge Data Set',
                    children: [
                    ]
                },
                {
                    label: 'The Medical Record as a Source Document',
                    children: [
                    ]
                }
            ]
        },
        {
            label: '2022',
            children: [
                {
                    label: 'ICD-10-CM Conventions6',
                    children: [
                        { label: 'ICD-10-CM Conventions7' },
                    ]
                },
            ]
        },
        {
            label: '2021',
            children: [
                {
                    label: 'ICD-10-CM Conventions8',
                    children: [
                        { label: 'ICD-10-CM Conventions9' },
                    ]
                },
            ]
        },
        {
            label: '2020',
            children: [
                {
                    label: 'ICD-10-CM Conventions10',
                    children: [
                        { label: 'ICD-10-CM Conventions11' },
                    ]
                },
            ]
        },
        {
            label: '2019',
            children: [
                {
                    label: 'ICD-10-CM Conventions12',
                    children: [
                        { label: 'ICD-10-CM Conventions13' },
                    ]
                },
            ]
        },
        {
            label: '2018',
            children: [
                {
                    label: 'ICD-10-CM Conventions14',
                    children: [
                        { label: 'ICD-10-CM Conventions15' },
                    ]
                },
            ]
        },
        {
            label: '2017',
            children: [
                {
                    label: 'ICD-10-CM Conventions16',
                    children: [
                        { label: 'ICD-10-CM Conventions17' },
                    ]
                },
            ]
        },
        {
            label: '2016',
            children: [
                {
                    label: 'ICD-10-CM Conventions18',
                    children: [
                        { label: 'ICD-10-CM Conventions19' },
                    ]
                },
            ]
        },
        {
            label: '2015',
            children: [
                {
                    label: 'ICD-10-CM Conventions20',
                    children: [
                        { label: 'ICD-10-CM Conventions21' },
                    ]
                },
            ]
        },
        {
            label: '2014',
            children: [
                {
                    label: 'ICD-10-CM Conventions22',
                    children: [
                        { label: 'ICD-10-CM Conventions23' },
                    ]
                },
            ]
        },
        {
            label: '2013',
            children: [
                {
                    label: 'ICD-10-CM Conventions24',
                    children: [
                        { label: 'ICD-10-CM Conventions25' },
                    ]
                },
            ]
        },
        {
            label: '2012',
            children: [
                {
                    label: 'ICD-10-CM Conventions26',
                    children: [
                        { label: 'ICD-10-CM Conventions27' },
                    ]
                },
            ]
        },
    ];

return (_ctx: any,_cache: any) => {
  const _component_q_tree = _resolveComponent("q-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_tree, {
      nodes: browseReference,
      "node-key": "label",
      "no-connectors": "",
      icon: "fa-solid fa-caret-right",
      class: "iodine-padding-left-lg",
      selected: selected.value,
      "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
      expanded: expanded.value,
      "onUpdate:expanded": _cache[1] || (_cache[1] = ($event: any) => ((expanded).value = $event))
    }, {
      "default-header": _withCtx((prop) => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, _toDisplayString(prop.node.label), 1)
        ])
      ]),
      _: 1
    }, 8, ["selected", "expanded"])
  ]))
}
}

})